<template>
  <div>
    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
        <h2 class="center mt-5">
          Our FREE scorekeeper is powerful enough for the pros,
        </h2>
      </vs-col>
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
        <h2 class="center mb-5">but designed for Joes</h2>
      </vs-col>
      <div style="padding: 10px">
        <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <div class="center">Make your games count with the Ballstar app.</div>
        </vs-col>
        <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <div class="center font-bold">
            Pts, Rebs, Asts, FG%, 3FG%
          </div>
        </vs-col>
        <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <div class="center">
            They're all here, not to mention averages, team leaders, and dozens
            of advanced analytics.
          </div>
        </vs-col>
      </div>
      <vs-divider class="my-3" />
      <vs-col
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="flex-end"
        vs-w="6"
        vs-sm="12"
        class="center-smartphone"
      >
        <router-link
          tag="div"
          class="vx-logo cursor-pointer flex items-center"
          to="/login"
        >
          <img
            width="50%"
            src="@/assets/images/pages/ballstar-tablet-mobile.png"
            alt="login"
            class="mx-auto"
          />
        </router-link>
      </vs-col>
      <vs-col
        vs-align="flex-start"
        vs-type="flex"
        vs-justify="flex-start"
        vs-w="6"
        vs-sm="12"
        class="flex-wrap"
      >
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="flex-start"
          vs-w="12"
          class="center-smartphone"
          ><h3>Decide with data.</h3></vs-row
        >
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="flex-start"
          vs-w="12"
          class="center-smartphone"
          ><h3>Halftime is too long.</h3></vs-row
        >
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="flex-start"
          vs-w="12"
          class="center-smartphone"
          ><h3>Tomorrow is too late.</h3></vs-row
        >
        <vs-divider class="my-3" />
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="flex-start"
          vs-w="12"
          class="center-smartphone"
          ><div>
            Make informed gametime decisions with Ballstar.
          </div></vs-row
        >
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="flex-start"
          vs-w="12"
          class="center-smartphone"
          ><div>
            Download your analytics department in an app today!
          </div></vs-row
        >
        <vs-row
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="flex-start"
          vs-w="12"
          class="my-3"
        >
          <vs-col
            vs-align="flex-start"
            vs-type="flex"
            vs-justify="flex-start"
            vs-lg="4"
            vs-w="12"
            vs-sm="6"
            class="my-3 center-smartphone"
          >
            <a
              href="https://apps.apple.com/us/app/ballstar-basketball-analytics/id1505662451"
              target="_tab"
            >
              <img
                src="@/assets/images/pages/apple-app-store-badge.png"
                alt="login"
                class="mx-auto"
              />
            </a>
          </vs-col>
          <vs-col
            vs-align="flex-start"
            vs-type="flex"
            vs-justify="flex-start"
            vs-lg="4"
            vs-w="12"
            vs-sm="6"
            class="my-3 center-smartphone"
          >
            <a
              href="https://play.google.com/store/apps/details?id=com.ballstar&hl=en_US"
              target="_tab"
            >
              <img
                height="40px"
                src="@/assets/images/pages/google-play-badge.png"
                alt="login"
                class="mx-auto"
              />
            </a>
          </vs-col>
          <vs-col
            vs-align="center"
            vs-justify="center"
            vs-w="6"
            vs-sm="12"
            class="text-center"
          >
            <vs-button
              type="line"
              class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
              size="large"
              ><a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdiDZVgbVqpuqTijlM1YkU5j_V66Waes6_wURrJWGsyOfrn8g/viewform"
                target="_blank"
                >Get Trained & Certified</a
              ></vs-button
            >
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-divider class="my-3" />
      <vs-row
        vs-align="flex-start"
        vs-type="flex"
        vs-justify="flex-start"
        vs-w="12"
      >
        <vs-col
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-xs="12"
        >
          <vx-card class="overflow-hidden">
            <div slot="no-body">
              <div class="p-6 flex justify-center items-center pb-0">
                <div class="truncate">
                  <h3 class="mb-1">Leagues</h3>
                  <h1 class="font-bold">1200+</h1>
                </div>
              </div>
            </div>
          </vx-card>
        </vs-col>
        <vs-col
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-xs="12"
        >
          <vx-card class="overflow-hidden">
            <div slot="no-body">
              <div class="p-6 flex justify-center items-center pb-0">
                <div class="truncate">
                  <h3 class="mb-1">Teams</h3>
                  <h1 class="font-bold">300+</h1>
                </div>
              </div>
            </div>
          </vx-card>
        </vs-col>
        <vs-col
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-xs="12"
        >
          <vx-card class="overflow-hidden">
            <div slot="no-body">
              <div class="p-6 flex justify-center items-center pb-0">
                <div class="truncate">
                  <h3 class="mb-1">Players</h3>
                  <h1 class="font-bold">15000+</h1>
                </div>
              </div>
            </div>
          </vx-card>
        </vs-col>
      </vs-row>
      <vs-divider class="my-3" />
    </vs-row>
  </div>
</template>
<script>
export default {
  name: "AppStore",
  data() {
    return {};
  },
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>
